// extracted by mini-css-extract-plugin
export default {"badge":"MenuCountBadge_badge__tHwK2"};